import gql from "graphql-tag";

export const MY_HR_GET_LAST_PAYCARD_DATA_BY_CONTRACT = gql`
  query getLastPaycardDataByContract($contractCode: String!) {
    getLastPaycardDataByContract(contractCode: $contractCode) {
      year
      month
      netWage
      otherBenefits
      allTaxDeductions
      otherDeductions
      grossWage
    }
  }
`;
